import React from "react";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "../style/About.css";
import "../style/Common.css";
import aboutUs from "../images/More.jpg";
import aboutUsMobile from "../images/doctor-checking.jpg";

import "../style/More.css";
import styles from "../style/Pricing.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import pricing3 from "../images/pricing-01.png";
import pricing2 from "../images/pricing-021.png";
import pricing4 from "../images/pricing-02.png";
import pricing1 from "../images/mild.png";
import boximg from "../images/lamaanboxbg.png";
import { useMediaQuery } from "react-responsive";

const Pricing = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <section className="more" id="more">
      <div className="about-us-container">
        <div className="about-us-content">
          <h1>We Are 70% More Affordable!</h1>
          <nav className="breadcrumb">
            <span>Home</span>
            <span className="separator">|</span>
            <span>Pricing Model</span>
          </nav>
        </div>
        <div className="about-us-image">
          {isMobile ? (
            <img src={aboutUsMobile} alt="About Us" className="mobile-image" />
          ) : (
            <img src={aboutUs} width={"24px"} alt="About Us" />
          )}
        </div>
      </div>
      <div className={styles.pricingTitleContainer}>
        <div className={styles.pricingTitle}>
          <h1>Top-Tier Clear Aligners. Region’s Best Prices.</h1>
          <p>
            Lamaan offers the highest quality clear aligner treatments at the
            most competitive prices in the region. Every treatment plan is
            crafted by licensed orthodontists and supported by premium
            manufacturing process ensuring safe, effective, and clinically
            supervised care from start to finish.
          </p>
        </div>
      </div>
      <div className={styles.pricingTable}>
        <div className={`${styles.card} ${styles.smallBusiness}`}>
          <div className={styles.icon}>
            <img
              src={pricing1}
              alt="resto"
              width={"55px"}
              height={"56px"}
              style={
                {
                  // make image white
                  // filter: "brightness(0) invert(1)",
                }
              }
            />
            {/* <FontAwesomeIcon icon={faShieldAlt} size="3x" /> */}
          </div>
          <h2>$900</h2>
          <h3>Mild</h3>
          <ul>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Doctor Assessment
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> X-Rays & 3D Scans
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Clinical Photos
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Treatment Plan
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Smile Simulation
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> {"Less Than 10 Aligners"}
            </li>
          </ul>
          <button
            className={styles.button}
            onClick={() => {
              window.location.href = "/#contact";
            }}
          >
            Get Started
          </button>
        </div>
        <div
          className={`${styles.card} ${styles.mediumBusiness} ${styles.featured}`}
        >
          <div className={styles.icon}>
            <img
              src={pricing2}
              alt="p2"
              width={"60px"}
              height={"61px"}
              style={{
                // make image white
                filter: "brightness(0) invert(1)",
              }}
            />
          </div>
          <h2>$1,600</h2>
          <h3>Standard</h3>
          <ul>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Doctor Assessment
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> X-Rays & 3D Scans
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Clinical Photos
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Treatment Plan
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Smile Simulation
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> {"10 - 30 Aligners"}
            </li>
          </ul>
          <button
            className={styles.button}
            onClick={() => {
              window.location.href = "/#contact";
            }}
          >
            Get Started
          </button>
        </div>
        <div className={`${styles.card} ${styles.corporateBusiness}`}>
          <div className={styles.icon}>
            <img src={pricing3} alt="resto" />
          </div>
          <h2>$2,300</h2>
          <h3>Advanced</h3>
          <ul>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Doctor Assessment
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> X-Rays & 3D Scans
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Clinical Photos
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Treatment Plan
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Smile Simulation
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> {"30 - 60 Aligners"}
            </li>
          </ul>
          <button
            className={styles.button}
            onClick={() => {
              window.location.href = "/#contact";
            }}
          >
            Get Started
          </button>
        </div>
        <div
          className={`${styles.card} ${styles.mediumBusiness} ${styles.featured}`}
        >
          <div className={styles.icon}>
            <img src={pricing4} alt="resto" />
          </div>
          <h2>$3,000</h2>
          <h3>Comprehensive</h3>
          <ul>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Doctor Assessment
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> X-Rays & 3D Scans
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Clinical Photos
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Treatment Plan
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> Smile Simulation
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} /> {"60+ Aligners"}
            </li>
          </ul>
          <button
            className={styles.button}
            onClick={() => {
              window.location.href = "/#contact";
            }}
          >
            Get Started
          </button>
        </div>
        <p className={`${styles.caption}`}>
          Treatment level is confirmed after case review by our licensed
          orthodontists.
        </p>
      </div>
      <div className={styles.pricingTitleContainer}>
        <div className={styles.pricingTitle}>
          <h1>The Best Quality. The Best Price. No Compromises.</h1>
          <p>
            With Lamaan, you don’t have to choose between expert care and
            affordability. We deliver clinical excellence, premium aligners, and
            in-person support — all at a price point that makes us the
            undisputed leader in value.
          </p>
          <img
            src={boximg}
            alt="box"
            className={styles.boximg}
            style={{
              width: isMobile ? "30rem" : "60rem",
              height: isMobile ? "25rem" : "50rem",
              borderRadius: "1rem",
              margin: "0 auto",
              marginTop: "2rem",
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default Pricing;
